import styled from "styled-components";

const InputAvatarUrl = styled.input`
  background-color: #4e4643;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  cursor: default;
  width: 98%;
`;

export default InputAvatarUrl;
